module.exports = __webpack_public_path__ + "img/柏柳.b28eb3a4.png";